function Settings04({
  color = 'currentColor',
  size = 20,
}) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
      <path d="M2.49994 6.66663L12.4999 6.66663M12.4999 6.66663C12.4999 8.04734 13.6192 9.16663 14.9999 9.16663C16.3807 9.16663 17.4999 8.04734 17.4999 6.66663C17.4999 5.28591 16.3807 4.16663 14.9999 4.16663C13.6192 4.16663 12.4999 5.28592 12.4999 6.66663ZM7.49994 13.3333L17.4999 13.3333M7.49994 13.3333C7.49994 14.714 6.38065 15.8333 4.99994 15.8333C3.61923 15.8333 2.49994 14.714 2.49994 13.3333C2.49994 11.9526 3.61923 10.8333 4.99994 10.8333C6.38065 10.8333 7.49994 11.9526 7.49994 13.3333Z" stroke="white" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  )
}

export default Settings04
